export { default } from './RegAndEditCategory';
